const PIXEL_ID = "1768916264190435";
const SCRIPT_ID = "meta-pixel-script";

type PixelValue = string | number | boolean | Record<string, string | number | boolean>;

type MetaPixelFunction = {
  (...args: PixelValue[]): void;
  callMethod?: (...args: PixelValue[]) => void;
  loaded?: boolean;
  queue?: PixelValue[][];
  version?: string;
};

declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}

let initialized = false;

function getOrCreateTracker(): MetaPixelFunction {
  if (window.fbq) return window.fbq;

  const tracker = ((...args: PixelValue[]) => {
    if (tracker.callMethod) {
      tracker.callMethod(...args);
      return;
    }

    tracker.queue?.push(args);
  }) as MetaPixelFunction;

  tracker.queue = [];
  tracker.loaded = true;
  tracker.version = "2.0";
  window.fbq = tracker;
  window._fbq = tracker;

  return tracker;
}

function loadPixelScript() {
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  script.onerror = () => undefined;
  document.head?.appendChild(script);
}

export function initializeMetaPixel() {
  if (typeof window === "undefined" || typeof document === "undefined" || initialized) return;

  try {
    const tracker = getOrCreateTracker();
    tracker("init", PIXEL_ID);
    tracker("track", "PageView");
    loadPixelScript();
    initialized = true;
  } catch {
    // Analytics must never block the landing page from rendering.
  }
}

export function trackCheckoutIntent() {
  try {
    window.fbq?.("track", "InitiateCheckout", {
      currency: "ARS",
      value: 16990,
      num_items: 1,
    });
  } catch {
    // Checkout navigation remains available if analytics is unavailable.
  }
}
